import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "name", "title", "path", "contentCourseDropdown", "contentCourseInput", "contentList",
                    "formatCourseDropdown", "formatCourseInput", "formatList", "sharingCourseDropdown",
                    "sharingCourseInput", "sharingList", "description", "copy", "notes", "saveBtn", "input",
                    "output", "validGroup", "kindCourseDropdown", "kindCourseInput", "kindList", "deleteBtn"]

  connect() {
    this.controllerName = `marketing--courses--entities--modal`
  }

  saveCourse() {
    if (this.validateSelectors().valid) {
      this.stopRefreshing()
      this.saveBtnTarget.disabled = true
      if (this.hasDeleteBtnTarget) {
        this.deleteBtnTarget.disabled = true
      }
      var data = {
        course: {
          id: this.element.dataset.id,
          name: this.nameTarget.value,
          title: this.titleTarget.value,
          path: this.pathTarget.value,
          description: this.descriptionTarget.value,
          copy: this.copyTarget.value,
          content: this.contentCourseInputTarget.dataset.content,
          format: this.formatCourseInputTarget.dataset.format,
          kind: this.kindCourseInputTarget.dataset.kind,
          sharing: this.sharingCourseInputTarget.dataset.sharing,
          notes: this.notesTarget.value
        },
        current_user: { current_user_id: currentUser.id }
      }
      this.requestSave(data)
    } else {
      alert(this.validateSelectors().error)
    }
  }

  deleteCourse() {
    this.stopRefreshing()
    this.saveBtnTarget.disabled = true
    if (this.hasDeleteBtnTarget) {
      this.deleteBtnTarget.disabled = true
    }
    var data = { course: { id: this.element.dataset.id, active: false }, current_user: { current_user_id: currentUser.id } }
    this.requestSave(data)
  }

  requestSave(data) {
    const token = $('meta[name=csrf-token]').attr('content');
    if (data.course.id) {
      var url = "/marketing/courses/entities/update"
      var method = "PUT"
    } else {
      var url = "/marketing/courses/entities/create"
      var method = "POST"
    }
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var course = response.data.cln
          this.close()
          if (this.getControllerByIdentifier("marketing--courses--entities--index").nameTarget("viewCourseBody")) {
            this.getControllerByIdentifier("marketing--courses--entities--index").nameTarget("viewCourseBody").remove()
            this.getControllerByIdentifier("marketing--courses--entities--index").nameTarget("viewTitle").innerText = "Nenhum Curso Selecionado"
          }
          if (data.course.id) {
            if (course.active) {
              this.application.courses.forEach((element, i) => {
                if (element.id == course.id) {
                  this.application.courses.splice(this.application.courses.indexOf(element), 1, course)
                }
              })
            } else {
              this.application.courses.forEach((element, i) => {
                if (element.id == course.id) {
                  this.application.courses.splice(this.application.courses.indexOf(element), 1)
                }
              })
            }
          } else {
            this.application.courses[this.application.courses.length] = course
          }
          this.getControllerByIdentifier("marketing--courses--entities--index").doDataTable()
        } else {
          this.saveBtnTarget.disabled = false
          if (this.hasDeleteBtnTarget) {
            this.deleteBtnTarget.disabled = true
          }
        }
        processingSnackbar(response.type, response.message, device)
      })
  }

  modalHtml(mode, courseId) {
    if (this.application.course_entities.can_create) {
      var saveBtnHtml = `<button type="button" class="btn btn-primary" data-action="click->${this.controllerName}#saveCourse" data-${this.controllerName}-target="saveBtn">Salvar</button>`
    } else {
      var saveBtnHtml = ``
    }

    if (this.application.course_entities.can_delete && mode == "edit") {
      var deleteBtnHtml = `<button type="button" class="btn btn-danger" data-action="click->${this.controllerName}#deleteCourse" data-${this.controllerName}-target="deleteBtn">Apagar</button>`
    } else {
      var deleteBtnHtml = ``
    }

    var html = `<div class="modal fade" data-controller="${this.controllerName}" data-${this.controllerName}-target="modal" id="courseModal" tabindex="-1" role="dialog" aria-labelledby="courseModalTitle" aria-hidden="true" data-id="${courseId}" data-keyboard="false" data-backdrop="static">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-header border-bottom">
                        <h6 class="modal-title"><strong>Novo Curso</strong></h6><br>
                        <button type="button" class="close" data-dismiss="modal" data-action="click->${this.controllerName}#close" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body p-3" data-${this.controllerName}-target="body">
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group form-valid-group" data-${this.controllerName}-target="validGroup" data-valid="false">
                              <div class="floating-label floating-label-sm">
                                <label for="nameCourseForm">Nome</label>
                                <input aria-describedby="nameCourseFormHelp" class="form-control form-valid-control" id="nameCourseForm" data-${this.controllerName}-target="name" data-action="blur->${this.controllerName}#validateField focus->${this.controllerName}#cleanValidations" placeholder="Nome" type="text" required>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group form-valid-group" data-${this.controllerName}-target="validGroup" data-valid="false">
                              <div class="floating-label floating-label-sm">
                                <label for="titleCourseForm">Título</label>
                                <input aria-describedby="titleCourseFormHelp" class="form-control form-valid-control" id="titleCourseForm" data-action="keyup->${this.controllerName}#bindInput blur->${this.controllerName}#validateField focus->${this.controllerName}#cleanValidations" data-${this.controllerName}-target="title output" placeholder="Título" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group form-valid-group" data-${this.controllerName}-target="validGroup" data-valid="false">
                              <div class="input-group input-group-sm">
                                <div class="floating-label floating-label-sm">
                                  <label for="pathCourseForm">URL para Course</label>
                                  <input readonly aria-describedby="pathCourseFormHelp" class="form-control form-valid-control" id="pathCourseForm" data-${this.controllerName}-target="path input" data-action="blur->${this.controllerName}#validateField focus->${this.controllerName}#cleanValidations" placeholder="URL do Curso" type="text" required>
                                </div>
                                <span class="input-group-icon mr-2">/</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group form-valid-group" data-${this.controllerName}-target="validGroup" data-valid="false">
                              <div class="floating-label floating-label-sm">
                                <label for="descriptionCourseForm">Descrição</label>
                                <textarea aria-describedby="descriptionCourseFormHelp" class="form-control textarea form-valid-control" id="descriptionCourseForm" placeholder="Descrição" type="text" required rows="3" data-${this.controllerName}-target="description" data-action="blur->${this.controllerName}#validateField focus->${this.controllerName}#cleanValidations"></textarea>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group form-valid-group" data-${this.controllerName}-target="validGroup" data-valid="false">
                              <div class="floating-label floating-label-sm">
                                <label for="copyCourseForm">Copy</label>
                                <textarea aria-describedby="copyCourseFormHelp" class="form-control textarea form-valid-control" id="copyCourseForm" placeholder="Copy" type="text" required rows="3" data-${this.controllerName}-target="copy" data-action="blur->${this.controllerName}#validateField focus->${this.controllerName}#cleanValidations"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 pr-1">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Conteúdo</label>
                                <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="contentCourseDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="contentCourseInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="contentList">
                                      <li data-content="clinic" class="li-selector dark">PJ Médica</li>
                                      <li data-content="booking" class="li-selector dark">Livro-Caixa</li>
                                      <li data-content="taxes" class="li-selector dark">Imposto de Renda</li>
                                      <li data-content="billing" class="li-selector dark">Recebimento</li>
                                      <li data-content="insurance" class="li-selector dark">Seguros</li>
                                      <li data-content="education" class="li-selector dark">Educação</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Tipo</label>
                                <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="kindCourseDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="kindCourseInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="kindList">
                                      <li data-kind="course" class="li-selector dark">Curso</li>
                                      <li data-kind="lesson" class="li-selector dark">Aula</li>
                                      <li data-kind="talk" class="li-selector dark">Talk Show</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-3">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Formato</label>
                                <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="formatCourseDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="formatCourseInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="formatList">
                                      <li data-format="paid" class="li-selector dark">Pago</li>
                                      <li data-format="free" class="li-selector dark">Gratuito</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-3 pl-1">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label>Compartilhamento</label>
                                <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="sharingCourseDropdown">
                                  <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="sharingCourseInput"></span></button>
                                  <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                                    <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                                    <ul class="ul-select" data-${this.controllerName}-target="sharingList">
                                      <li data-sharing="public" class="li-selector dark">Público</li>
                                      <li data-sharing="client" class="li-selector dark">Clientes</li>
                                      <li data-sharing="intern" class="li-selector dark">Interno</li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <div class="form-group">
                              <div class="floating-label floating-label-sm">
                                <label for="notesCourseForm">Anotações</label>
                                <input aria-describedby="notesCourseFormHelp" class="form-control" id="notesCourseForm" data-${this.controllerName}-target="notes" placeholder="Anotações" type="text" required>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer border-top">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" data-action="click->${this.controllerName}#close" style="width:85px;">Fechar</button>
                        ${deleteBtnHtml}
                        ${saveBtnHtml}
                      </div>
                    </div>
                  </div>
                </div>`
    var controller = this
    new Promise(function (resolve) {
      resolve($('body').append(html))
    }).then(() => {
      this.application.getControllerForElementAndIdentifier(document.querySelector('#courseModal'), "marketing--courses--entities--modal").open()
      this.application.getControllerForElementAndIdentifier(document.querySelector('#courseModal'), "marketing--courses--entities--modal").refreshSaveBtn()
      this.application.getControllerForElementAndIdentifier(document.querySelector('#courseModal'), "marketing--courses--entities--modal").dataValidation(courseId)
      if (mode == "edit") {
        this.application.getControllerForElementAndIdentifier(document.querySelector('#courseModal'), "marketing--courses--entities--modal").fetchCourse(courseId)
      }
      changeStringToPath($('#pathCourseForm'))
      selector()
    })
  }

  open() {
    document.body.classList.add("modal-open");
    this.element.setAttribute("style", "display: block;");
    this.element.classList.add("show");
    const html = `<div class="modal-backdrop fade show"></div>`
    document.body.insertAdjacentHTML("beforeend", html)
    floatingLabel();
    selector()
  }

  close() {
    document.body.classList.remove("modal-open");
    this.element.removeAttribute("style");
    this.element.classList.remove("show");
    document.getElementsByClassName("modal-backdrop")[0].remove();
    this.modalTarget.remove()
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  fetchCourse(courseId) {
    var course = ``
    this.application.courses.forEach(element => {
      if (element.id == courseId) {
        course = element
      }
    });

    
    this.nameTarget.value = course.name
    this.titleTarget.value = course.title
    this.pathTarget.value = course.path
    this.descriptionTarget.value = course.description
    this.copyTarget.value = course.copy
    this.notesTarget.value = course.notes
    this.contentCourseDropdownTarget.value = course.content
    this.contentCourseInputTarget.innerText = course.content_pretty
    this.kindCourseDropdownTarget.value = course.kind
    this.kindCourseInputTarget.innerText = course.kind_pretty
    this.formatCourseDropdownTarget.value = course.format
    this.formatCourseInputTarget.innerText = course.format_pretty
    this.sharingCourseDropdownTarget.value = course.sharing
    this.sharingCourseInputTarget.innerText = course.sharing_pretty

    this.validGroupTargets.forEach(element => {
      element.dataset.valid = true
    });

    this.getControllerByIdentifier("app--helpers--forms").floatingLabel()
  }

  dataValidation(courseId) {
    this.nameTarget.dataset.objColumn = "name"
    this.nameTarget.dataset.filterColumn = "id"
    this.nameTarget.dataset.filterValue = courseId
    this.titleTarget.dataset.objColumn = "title"
    this.titleTarget.dataset.filterColumn = "id"
    this.titleTarget.dataset.filterValue = courseId
    this.pathTarget.dataset.objColumn = "path"
    this.pathTarget.dataset.filterColumn = "id"
    this.pathTarget.dataset.filterValue = courseId
    this.descriptionTarget.dataset.objColumn = "description"
    this.descriptionTarget.dataset.filterColumn = "id"
    this.descriptionTarget.dataset.filterValue = courseId
    this.copyTarget.dataset.objColumn = "copy"
    this.copyTarget.dataset.filterColumn = "id"
    this.copyTarget.dataset.filterValue = courseId
  }

  cleanValidations(ev) {
    ev.target.classList.remove("invalid-field")
    if (ev.target.nextElementSibling) {
      ev.target.nextElementSibling.remove()
    }
  }

  validateField(ev) {
    var data = {
      validations: {
        obj_column: ev.target.dataset.objColumn,
        obj_value: ev.target.value,
        filter_column: ev.target.dataset.filterColumn,
        filter_value: ev.target.dataset.filterValue,
      }
    }


    const token = $('meta[name=csrf-token]').attr('content');
    const url = "/marketing/courses/entities/validate_field"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.valid) {
          ev.target.closest(".form-valid-group").dataset.valid = true
        } else {
          ev.target.closest(".form-valid-group").dataset.valid = false
          ev.target.classList.add("invalid-field")
          const html = `<div class="invalid-warning my-1 py-1" data-${this.controllerName}-target="invalid"></div>`
          ev.target.parentElement.insertAdjacentHTML("beforeend", html);
          response.messages.forEach(message => {
            ev.target.nextElementSibling.insertAdjacentHTML("beforeend", message);
          });
        }
      })
  }

  validateSelectors() {
    if (this.contentCourseInputTarget.innerText == "") {
      return { valid: false, error: "Conteúdo não pode ficar em branco" }
    } else if (this.formatCourseInputTarget.innerText == "") {
      return { valid: false, error: "Formato não pode ficar em branco" }
    } else if (this.sharingCourseInputTarget.innerText == "") {
      return { valid: false, error: "Compartilhamento não pode ficar em branco" }
    } else if (this.kindCourseInputTarget.innerText == "") {
      return { valid: false, error: "Tipo não pode ficar em branco" }
    } else {
      return { valid: true }
    }
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  bindInput() {
    var value = this.outputTarget.value
    if (value.length >= 1) {
      this.inputTarget.focus()
      this.inputTarget.value = fromStringToPath(value)
      this.inputTarget.closest('.floating-label').classList.add("has-value")
      this.inputTarget.closest('.floating-label').classList.add("is-focused")
      this.inputTarget.blur()
      this.outputTarget.focus()
    }
  }

  fromStringToBoolean(string) {
    if (string === "true") {
      return true
    } else if (string === "false") {
      return false
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

}
